import {
    Card,
    CardBody,
    Input,
    TableRow,
    Table,
    TableCell,
    TableContainer,
    TableHeader,
    Button,
} from '@windmill/react-ui';
import ExportDataXlsx from 'components/common/ExportDataXlsx';
import OnewayPickupBasicRateTable from 'components/OnewayPickup/Onewaypickuptable';
import DataWrapper from './DataWrapper';
import NotFound from 'components/table/NotFound';
import PageTitle from 'components/Typography/PageTitle';
import { SidebarContext } from 'context/SidebarContext';
import Somethingwentwrong from 'pages/Somethingwentwrong';
import useAsync from 'hooks/useAsync';
import useFilter from 'hooks/useFilter';
import { useState, useContext, useEffect } from 'react';
import OnewayPickupBasicRateServices from 'services/OnewayPickupServices';
import { FiPlus } from 'react-icons/fi';
import OnewayPickupBasicRateDrawer from 'components/drawer/OnewayPickupDrawer';
import MainDrawer from 'components/drawer/MainDrawer';
import DeleteModal from 'components/modal/DeleteModal';
import useToggleDrawer from 'hooks/useToggleDrawer';
import sidebar from 'routes/sidebar';

const OnewayPickupBasicRate = () => {
    const adminInfo = localStorage.getItem('adminInfo')
        ? JSON.parse(localStorage.getItem('adminInfo'))
        : null;
    const { toggleDrawer } = useContext(SidebarContext);
    const { title, serviceId } = useToggleDrawer();
    const [status, setStatus] = useState('');
    const { data, loading, error } = useAsync(
        OnewayPickupBasicRateServices.getAllOnewayPickupBasicRate
    );


    const isDataArray = Array.isArray(data?.data); // Check if data is an array

    const safeData = isDataArray ? data?.data : []; // Use empty array if data is not an array

    const isAdmin = adminInfo?.id === 1;

    const hideView = adminInfo?.permission?.some(
        (perm) => perm.id_tab === 'one way basic' && perm.view === 1
    );

    const hideDelete = adminInfo?.permission?.some(
        (perm) => perm.id_tab === 'one way basic' && perm.delete === 1
    );

    const hideEdit = adminInfo?.permission?.some(
        (perm) => perm.id_tab === 'one way basic' && perm.edit === 1
    );

    const hideAdd = adminInfo?.permission?.some(
        (perm) => perm.id_tab === 'one way basic' && perm.add === 1
    );

    const hideExport = adminInfo?.permission?.some(
        (perm) => perm.id_tab === 'one way basic' && perm.export === 1
    );
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const {
        onewayPickupBasicRateRef,
        dataTable,
        serviceData,
        handleSubmitOnewayPickupBasicRate,
        currentPage,
    } = useFilter(Array.isArray(data?.data) ? data?.data : [], itemsPerPage);

    useEffect(() => {
        if (serviceData.length !== 0) {
            setItemsPerPage(serviceData.length);
        }
    }, [serviceData]);
    const updatedData = safeData.map(({ id, ...rest }) => rest);

    useEffect(() => {
        if (data?.status) {
            setStatus(data.status);
        } else {
            setStatus(false);
        }
    }, [data?.status]);

    const finalData = data?.data?.map((item, itemIndex) => {
        const vehicleTypes =
            item.vehicle_type_id
                ?.map(id => item.vehicle_type_names?.[id])
                .join("\n") || "";

        const minRate = Object.values(item.min_rate || {}).join("\n");
        const minKm = Object.values(item.min_km || {}).join("\n");
        const extraKm = Object.values(item.extra_km || {}).join("\n");

        return {
            "SI.No": itemIndex + 1,
            "From City": item.from_city_name?.join("\n") || "",
            "To City": item.to_city_name?.join("\n") || "",
            "Vehicle Type": vehicleTypes,
            "Min Rate": minRate,
            "Min KM": minKm,
            "Extra KM": extraKm,
        };
    });



    return (
        <>
            {hideView && (
                <>
                    <DeleteModal id={serviceId} title={title} />

                    <MainDrawer>
                        <OnewayPickupBasicRateDrawer id={serviceId} />
                    </MainDrawer>

                    <PageTitle sidebar={sidebar().sidebar} />

                    <Card className="min-w-0 shadow-xs overflow-hidden bg-white dark:bg-gray-800 mb-5">
                        <CardBody>
                            <div className="flex gap-6 items-center">
                                <div className="flex-1">
                                    <Input
                                        ref={onewayPickupBasicRateRef}
                                        className="border h-10 text-sm focus:outline-none block w-full bg-gray-100 border-transparent focus:bg-white"
                                        type="search"
                                        name="search"
                                        placeholder="Quick Search"
                                        autoComplete="off"
                                        onChange={handleSubmitOnewayPickupBasicRate}
                                    />
                                </div>

                                {hideAdd && (
                                    <Button
                                        onClick={toggleDrawer}
                                        className="w-56 rounded-md h-10"
                                    >
                                        <span className="mr-3">
                                            <FiPlus />
                                        </span>
                                        Add Oneway Pickup Rate
                                    </Button>
                                )}

                                {hideExport && (
                                    <ExportDataXlsx
                                        exportDataXlsx={finalData}
                                        fileNames="One way Pickup Basic Rate"
                                    />
                                )}
                            </div>
                        </CardBody>
                    </Card>

                    <DataWrapper loading={loading} error={error} status={status}>
                        {serviceData.length ? (
                            <TableContainer className="mb-8">
                                <div
                                    className="overflow-y-scroll"
                                    style={{ maxHeight: '65vh', scrollbarWidth: 'thin' }}
                                >
                                    <Table>
                                        <TableHeader className="custom-table-header capitalize z-10 text-center sticky top-0 text-sm">
                                            <TableRow>
                                                <TableCell>Sl.No.</TableCell>
                                                <TableCell>From City</TableCell>
                                                <TableCell>To City</TableCell>
                                                <TableCell>Vehicle Type</TableCell>
                                                <TableCell>Min Rate</TableCell>
                                                <TableCell>Min KM</TableCell>
                                                <TableCell>Extra KM</TableCell>

                                                <TableCell>Status</TableCell>
                                                <TableCell>Actions</TableCell>
                                            </TableRow>
                                        </TableHeader>
                                        <OnewayPickupBasicRateTable
                                            OnewayPickupBasicRate={serviceData}
                                            perpage={itemsPerPage}
                                            currentPage={currentPage}
                                            hideDelete={hideDelete}
                                            hideEdit={hideEdit}
                                        />
                                    </Table>
                                </div>
                            </TableContainer>
                        ) : (
                            <>
                                {data.status !== true ? (
                                    <Somethingwentwrong title="Something Went Wrong, Try After Sometime" />
                                ) : (
                                    <NotFound title="There are no Oneway Pickup Basic Rates." />
                                )}
                            </>
                        )}
                    </DataWrapper>
                </>
            )}
        </>
    );
};

export default OnewayPickupBasicRate;
